<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CTBxHm/tc-custom/9781488088377.jpg?1700957948507" alt="This image is the cover for the book Bodyguard for Christmas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bodyguard for Christmas
      </h1>
      <p class="bookDescription body article font2">
        <b>To protect his son on Christmas, a single father seeks refuge with a beautiful bodyguard in this suspenseful holiday romance.</b><br/><br/>When his young son is nearly kidnapped, assistant district attorney Colton Gale needs a safe place to hide over Christmas—and a live-in bodyguard. Though former military police officer Jasmine McNeal fights to shield them 24/7, she refuses to get attached. But growing close to the little boy and his father might be her only shot at keeping them alive—and becoming a family beyond the holidays.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carol J. Post
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?91125d46